import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { first } from 'rxjs';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, Languages, RefundApprovalDecision, ServiceStatus, TransitConfirmVesselEntranceDecision, TransitIssueResolutionDecision, TransitRequestWFSteps } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { AppConfig } from 'src/app/shared/services/app.config';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { Router } from '@angular/router';
import { TransitRequestComponent } from '../transit-request/transit-request.component';


@Component({
  selector: 'app-transit-issue-resolution',
  templateUrl: './transit-issue-resolution.component.html'
})
export class TransitIssueResolutionComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitRequestWFSteps.TransitIssueResolution;
  issueResolutionForm: FormGroup;
  submitted = false;
  showRequest = false;
  isErrorMessage = false;
  lockTaskErrorMessage = false;
  decision = TransitIssueResolutionDecision;
  decisionKeys = Object.keys(this.decision);
  decisionValue: number;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest;
  displayedLang: string;
  currentUser: User = new User();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  isLoaded: boolean = false;
  @ViewChild('TransitRequest', { static: false }) TransitRequest: TransitRequestComponent;
  @Input() public isShow: boolean = true;
  responseObj: ResponseObject = new ResponseObject();
  agentId: string;
  // uploader helpers for ClearanceEvidence
  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;
  clearanceEvidenceProgress: number = 0;
  clearanceEvidenceAttachment: any = null;
  clearanceFile: File | null = null;
  stepData: any;
  stepHistoryId: any;
  isPaid: boolean;
  docURL: string = '';
  uploadFolder = AppConfig.settings.apiServer.EBookingUploadsFolder || 'EBooking';
  showTransitIssueDescription: boolean;
  transitIssueDescription: string;
  requestTransitDate: any;
  minTransitDate = new Date();
  feesEstimationExpiration: any;
  requestStatuses: number[] = [];


  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private fileService: fileService,
    private translate: TranslateService,
    private router: Router,
  ) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      // this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm(null);
  }

  receivePaidFlag(event) {
    if (event === undefined) return;
    this.isPaid = event;
    this.decisionKeys = this.isPaid ? this.decisionKeys.filter(key => key !== 'CANCEL_TRANSIT_NOTPAID') : this.decisionKeys.filter(key => key !== 'CANCEL_TRANSIT_PAID');
  }

  receiveFeesValue(event) {
    if (event === undefined) return;
    this.requestTransitDate = event.TransitDate;
  }

  receiveFeesEstimationValidation(event) {
    if (event === undefined) return;
    this.feesEstimationExpiration = event;
  }

  buildForm(decision) {
    this.issueResolutionForm = this.formBuilder.group({
      Decision: ['', Validators.required],
    });
    if (decision === TransitIssueResolutionDecision.UPLOAD_CLEARANCE) {
      this.issueResolutionForm = this.formBuilder.group({
        Decision: ['', Validators.required],
        ClearanceEvidence: [''],
        CommitToPayPenalties: [false, Validators.requiredTrue]
      });
    } else if (decision === TransitIssueResolutionDecision.EDIT_TRANSIT_DATE) {
      this.issueResolutionForm = this.formBuilder.group({
        Decision: ['', Validators.required],
        TransitDate: ['', [Validators.required, this.sameAsCurrentTransitDateValidator(), this.exceedFeesEstimationExpirationTransitDateValidator()]],
        CommitToPayPenalties: [false, Validators.requiredTrue]
      });
    }
    else if (decision === TransitIssueResolutionDecision.CANCEL_TRANSIT_NOTPAID) {
      this.issueResolutionForm = this.formBuilder.group({
        Decision: ['', Validators.required],
        CommitToPayPenalties: [false, Validators.requiredTrue]
      });
    } else if (decision === TransitIssueResolutionDecision.CANCEL_TRANSIT_PAID) {
      this.issueResolutionForm = this.formBuilder.group({
        Decision: ['', Validators.required],
        CommitToPayPenalties: [false, Validators.requiredTrue],
        RequestRefund: [false, Validators.requiredTrue]
      });
    }
  }

  changeDecision(value) {
    this.buildForm(value);
    this.issueResolutionForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  get f() { return this.issueResolutionForm.controls; }

  // get minTransitDate(): Date | null {
  //   if (!this.requestTransitDate) return null;
  //   const minDate = new Date(this.requestTransitDate);
  //   minDate.setDate(minDate.getDate() + 1);
  //   return minDate;
  // }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        // this.requestStatus = this.baseRequestDTO.StatusId;
        this.requestStatuses = this.baseRequestDTO.RequestStatuses.map(s => s.StatusId);
        this.isLoaded = true;
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistoryById();
        } else if (!this.requestStatuses.includes(ServiceStatus.Transit_PendingTransitIssueResolution)) {
          this.formMode = FormMode.Readonly;
          this.getTransitRequestWFHistory();
        } else if (this.requestStatuses.includes(ServiceStatus.Transit_PendingTransitIssueResolution)) {
          this.formMode = FormMode.Add;
          this.getConfirmVesselEntranceData();
        }
      }
    )
  }
  getConfirmVesselEntranceData() {
    // Get Step Data of Confirm Vessel Entrance
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, TransitRequestWFSteps.ConfirmVesselEntrance).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          if (!this.stepData) return;
          this.transitIssueDescription = this.stepData.Reason;
          this.showTransitIssueDescription = true;
        }
      }
    );
  }

  getTransitRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepId(this.baseRequestId, this.stepId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitRequestWFHistoryCompleted(this.stepData);
        }
      }
    );
  }

  getTransitRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdById(this.baseRequestId, this.stepId, this.stepHistoryId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitRequestWFHistoryCompleted(this.stepData);
      }
    );
  }

  getTransitRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    this.decisionValue = this.stepData.Decision;
    this.changeDecision(this.decisionValue);
    if (this.decisionValue == TransitIssueResolutionDecision.UPLOAD_CLEARANCE) {
      if (stepData.ClearanceEvidence && stepData.ClearanceEvidence != '') {
        this.docURL = this.uploadUrl + this.uploadFolder + '/' + stepData.ClearanceEvidence;
      }
      this.issueResolutionForm.patchValue({
        CommitToPayPenalties: true
      });
    } else if (this.decisionValue == TransitIssueResolutionDecision.EDIT_TRANSIT_DATE) {
      this.issueResolutionForm.patchValue({
        TransitDate: new Date(stepData.TransitDate),
        CommitToPayPenalties: true
      });
    } else if (this.decisionValue == TransitIssueResolutionDecision.CANCEL_TRANSIT_NOTPAID) {
      this.issueResolutionForm.patchValue({
        CommitToPayPenalties: true
      });
    } else if (this.decisionValue == TransitIssueResolutionDecision.CANCEL_TRANSIT_PAID) {
      this.issueResolutionForm.patchValue({
        CommitToPayPenalties: true,
        RequestRefund: true
      });
    }
    this.issueResolutionForm.disable();
  }

  onClearanceFileSelected(event: any) {
    const file: File = event?.target?.files && event.target.files[0];
    if (!file) {
      return;
    }
    this.alertService.clear();

    // validate extension
    if (!this.fileService.IsFileExtentionValid(event)) {
      this.issueResolutionForm.get('ClearanceEvidence')?.setValue('');
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        this.alertService.error(res);
      });
      return;
    }

    // validate size
    if (!this.fileService.IsFileSizeValid(event)) {
      this.issueResolutionForm.get('ClearanceEvidence')?.setValue('');
      this.translate.get('FRONT_USER.NotAllowedFileSizeMessage').subscribe((res: string) => {
        this.alertService.error(res);
      });
      return;
    }

    // set local file and reset progress
    this.clearanceFile = file;
    this.clearanceEvidenceProgress = 0;
    this.issueResolutionForm.get('ClearanceEvidence')?.setValue(file.name);

    // prepare FormData and upload to server (uses same endpoint as supplier registration)
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', 'ClearanceEvidence');
    formData.append('FolderName', this.uploadFolder);

    this.fileService.fileUploader(formData).subscribe(eventResp => {
      if (eventResp.type === HttpEventType.UploadProgress) {
        const percentDone = Math.round(100 * eventResp.loaded / (eventResp.total || 1));
        this.clearanceEvidenceProgress = percentDone;
      } else if (eventResp instanceof HttpResponse) {
        const body = eventResp.body;
        const data = body && body.Data ? body.Data : null;
        const url = data && (data.Url || data.UrlPath || data.UrlPathName || data.Path) ? (data.Url || data.UrlPath || data.UrlPathName || data.Path) : null;
        if (url) {
          // store attachment so template can render a link
          this.clearanceEvidenceAttachment = {
            URL: url,
            Name: file.name
          };
          // ensure control is set (name already set) and clear any errors
          this.issueResolutionForm.get('ClearanceEvidence')?.setValue(url);
          this.issueResolutionForm.get('ClearanceEvidence')?.setErrors(null);
        } else {
          // unexpected response
          this.translate.get('FRONT_USER.FILE_UPLOAD_FAILED').subscribe((msg: string) => this.alertService.error(msg));
        }
      }
    }, err => {
      // upload error
      this.clearanceEvidenceProgress = 0;
      this.translate.get('FRONT_USER.FILE_UPLOAD_FAILED').subscribe((msg: string) => this.alertService.error(msg));
    });
  }

  sameAsCurrentTransitDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || !this.TransitRequest?.transitRequest?.AgentTransitDate) {
        return null;
      }
      const selectedDate = new Date(control.value);
      const agentTransitDate = new Date(
        this.TransitRequest.transitRequest.AgentTransitDate
      );
      if (selectedDate === agentTransitDate) {
        return { sameAsCurrent: true };
      }
      return null;
    };
  }

  exceedFeesEstimationExpirationTransitDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || !this.feesEstimationExpiration) {
        return null;
      }
      const selectedDate = new Date(control.value);
      const feesEstimationExpirationDate = new Date(
        this.feesEstimationExpiration
      );
      if (selectedDate > feesEstimationExpirationDate) {
        return { exceedFeesEstimationExpiration: true };
      }
      return null;
    };
  }


  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.issueResolutionForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    this.transitRequestCustomObj.StepId = this.stepId;
    if (this.decisionValue == TransitIssueResolutionDecision.EDIT_TRANSIT_DATE && this.issueResolutionForm.controls['TransitDate'].value) {
      this.issueResolutionForm.patchValue({
        TransitDate: this.issueResolutionForm.controls['TransitDate'].value.toLocaleString('en-US')
      });
    }
    this.transitRequestCustomObj.StepData = JSON.stringify(this.issueResolutionForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.TransitRequest.feesRequest.feesDetailsForm.get('DirectionId')?.value;

    this.transitService.SubmitTransitIssueResolutionDecision(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.issueResolutionForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages && data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
